var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import styles from '../RadioGroup.scss';
import classNames from 'classnames';
import WixComponent from '../../BaseComponents/WixComponent';

var RadioButton = function (_WixComponent) {
  _inherits(RadioButton, _WixComponent);

  function RadioButton(props) {
    _classCallCheck(this, RadioButton);

    var _this = _possibleConstructorReturn(this, (RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).call(this, props));

    _this.id = uniqueId();
    return _this;
  }

  _createClass(RadioButton, [{
    key: 'render',
    value: function render() {
      var _classNames, _classNames2, _classNames3;

      var _props = this.props,
          value = _props.value,
          vAlign = _props.vAlign,
          checked = _props.checked,
          disabled = _props.disabled,
          name = _props.name,
          type = _props.type,
          _onChange = _props.onChange,
          style = _props.style;


      var radioClasses = classNames((_classNames = {}, _defineProperty(_classNames, styles.radio, true), _defineProperty(_classNames, styles.checked, checked), _defineProperty(_classNames, styles.disabled, disabled), _classNames));

      var labelClasses = classNames((_classNames2 = {}, _defineProperty(_classNames2, styles.vcenter, vAlign === 'center'), _defineProperty(_classNames2, styles.vtop, vAlign === 'top'), _classNames2));

      var buttonClasses = classNames((_classNames3 = {}, _defineProperty(_classNames3, styles.checked, checked), _defineProperty(_classNames3, styles.radioButton, true), _classNames3));

      var _props2 = this.props,
          icon = _props2.icon,
          children = _props2.children;

      return type === 'button' ? React.createElement(
        'button',
        {
          className: buttonClasses,
          checked: checked,
          disabled: disabled,
          id: this.id,
          onClick: function onClick() {
            return !checked && !disabled ? _onChange(value) : null;
          }
        },
        icon ? React.createElement(
          'span',
          null,
          icon
        ) : null,
        children ? React.createElement(
          'span',
          null,
          children
        ) : null
      ) : React.createElement(
        'div',
        { className: styles.radioWrapper, style: style },
        React.createElement('input', {
          type: 'radio',
          name: name,
          value: value,
          id: this.id,
          checked: checked,
          disabled: disabled,
          onChange: function onChange() {
            return !checked && !disabled ? _onChange(value) : null;
          }
        }),
        React.createElement(
          'label',
          { htmlFor: this.id, className: labelClasses, 'data-hook': 'radio-label' },
          React.createElement('div', { className: radioClasses }),
          React.createElement(
            'div',
            { className: styles.children },
            this.props.children
          )
        )
      );
    }
  }]);

  return RadioButton;
}(WixComponent);

RadioButton.defaultProps = {
  vAlign: 'center'
};

RadioButton.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  vAlign: PropTypes.oneOf(['center', 'top']),
  name: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.any,
  style: PropTypes.object,
  type: PropTypes.string
};

RadioButton.displayName = 'RadioGroup.Button';

export default RadioButton;
//# sourceMappingURL=RadioButton.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/RadioGroup/RadioButton/RadioButton.js